import { useQuery } from "@apollo/client";

import { GqlCourseGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { CourseListRoute_GetAllDocument } from "../queries.generated";

export const COURSE_GET_ALL = CourseListRoute_GetAllDocument;

export default function useCourseListRoute_GetAll(params: GqlCourseGetAllParams) {
    const { data, loading, error } = useQuery(COURSE_GET_ALL, {
        variables: { params: params },
    });

    const queryInfo = data?.courseGetAll?.queryInfo;
    const [, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);
    return {
        loading,
        error,
        total: total,
        data: data?.courseGetAll?.data,
    };
}
